export const locales = {
	closeBtn: 'Fermer le menu'
};
